"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationsRequestBuilder = void 0;
class RecommendationsRequestBuilder {
    constructor() {
        this.request = {
            currencyCode: 'GBP',
            eventType: 'detail-page-view',
            pageSize: 10,
        };
    }
    currency(code) {
        this.request.currencyCode = code;
        return this;
    }
    filter(filter) {
        if (this.request.filter && Object.keys(this.request.filter).length > 0) {
            throw new Error('a filter is already set on the request');
        }
        this.request.filter = filter;
        return this;
    }
    pageSize(size) {
        this.request.pageSize = size;
        return this;
    }
    products(products) {
        this.request.products = products;
        return this;
    }
    eventType(eventType) {
        this.request.eventType = eventType;
        return this;
    }
    build() {
        if (this.request.products && this.request.products.length < 1) {
            throw new Error('No products specified in the products array. Please add products to the recommendations request by calling `.products` on the builder class.');
        }
        return structuredClone(this.request);
    }
}
exports.RecommendationsRequestBuilder = RecommendationsRequestBuilder;
